import { useState, useCallback } from 'react';
import { socket } from '../lib/socket';
import { useSocketEvent } from './useSocketEvent';
import {
  EVENTS,
  CHAT_MAX_LENGTH,
  type ChatMessage,
  type ChatChannel,
  type ChatHistoryPayload,
  type ChatMessagePayload,
} from '@flip7/shared';

export function useChat(roomCode: string | null) {
  const [roomMessages, setRoomMessages] = useState<ChatMessage[]>([]);
  const [spectatorMessages, setSpectatorMessages] = useState<ChatMessage[]>([]);
  const [unreadRoom, setUnreadRoom] = useState(0);
  const [unreadSpectator, setUnreadSpectator] = useState(0);

  useSocketEvent<ChatHistoryPayload>(EVENTS.CHAT_HISTORY, (data) => {
    setRoomMessages(data.room);
    setSpectatorMessages(data.spectator);
  });

  useSocketEvent<ChatMessagePayload>(EVENTS.CHAT_MESSAGE, (msg) => {
    if (msg.channel === 'room') {
      setRoomMessages(prev => [...prev.slice(-99), msg]);
      setUnreadRoom(prev => prev + 1);
    } else {
      setSpectatorMessages(prev => [...prev.slice(-99), msg]);
      setUnreadSpectator(prev => prev + 1);
    }
  });

  const sendChat = useCallback((channel: ChatChannel, content: string) => {
    if (!roomCode) return;
    const trimmed = content.trim();
    if (!trimmed || trimmed.length > CHAT_MAX_LENGTH) return;
    socket.emit(EVENTS.SEND_CHAT, { roomCode, channel, content: trimmed });
  }, [roomCode]);

  const clearUnread = useCallback((channel: ChatChannel) => {
    if (channel === 'room') setUnreadRoom(0);
    else setUnreadSpectator(0);
  }, []);

  return {
    roomMessages,
    spectatorMessages,
    unreadRoom,
    unreadSpectator,
    sendChat,
    clearUnread,
  };
}
